module.exports = __webpack_public_path__ + "img/08.4570f67a.png";